export enum Type {
    SECTION = 100,
    TEXTITEM = 1,
    PARAGRAPH = 3,
    MULTIPLECHOICE = 4,
    LABEL = 6,
    CHECKBOX = 7,
    DROPDOWN = 8,
    SIGNATURE = 10,
    DATEPICKER = 11,
    CALCULATION = 12
}